import { get } from 'lodash';

import {
  DocumentTemplateModel,
  DocumentTemplateTypeEnum,
} from '../../../../shared/models';
import yup from '../../../../utils/yup-extended';
import { defaultElectronicSignatureSettings } from '../default-settings';
import { ElectronicSignatureCheckInput } from '../electronic-signature-check-input';

export const electronicSignatureSettingsSchema = (): yup.SchemaOf<
  ElectronicSignatureCheckInput['settings']
> => {
  return yup
    .object({
      automaticApproval: yup
        .boolean()
        .default(defaultElectronicSignatureSettings.automaticApproval),
      documentTemplateKey: yup
        .string()
        .required()
        .defined()
        .typeError('${path} must be a string')
        .test('document-type-key', function (value) {
          if (!value) return true;
          const documentTemplates = get(
            this?.options?.context,
            'documentTemplates',
            [],
          ) as DocumentTemplateModel[];
          const documentTemplateKeys = documentTemplates
            .filter(
              (documentTemplate) =>
                documentTemplate.type ===
                DocumentTemplateTypeEnum.electronic_signature,
            )
            .map((documentTemplate) => documentTemplate.key);

          const { createError, path } = this;

          return (
            documentTemplateKeys.includes(value) ||
            createError({
              path,
              message: `${path} must be one of document template key for electronic signature`,
            })
          );
        }),
    })
    .noUnknown()
    .defined();
};
